// localStorage key the OAuth popup uses to hand the auth code over to the opener
// when window.opener is unavailable (severed by the provider's cross-origin redirects)
export const INTEGRATION_AUTH_STORAGE_KEY = 'integrationAuth';

export function sendIntegrationRequest(name, data) {
    switch (name.toLowerCase()) {
        case 'facebook':
            return integrateFacebook(data);
        default:
            console.log('nothing integrate');
    }
}

async function addSdkFile(id, src, tag = 'script', dom = document) {
    let js,
        fjs = dom.getElementsByTagName(tag)[0];
    if (dom.getElementById(id)) {
        return;
    }
    js = dom.createElement(tag);
    js.id = id;
    js.src = src;
    fjs.parentNode.insertBefore(js, fjs);
}


async function integrateFacebook(data) {
    await addSdkFile('facebook-jssdk', 'https://connect.facebook.net/en_US/sdk.js');
    await initFacebook();

    async function initFacebook() {
        window.fbAsyncInit = function () {
            window.FB.init(data.initOptions);
        };

    }

    await new Promise(resolve => setTimeout(resolve, 500));
    return await new Promise((resolve, reject) => {
        window.FB.login(function (response) {
            if (response.status === 'connected') {
                window.FB.api(`/${response.authResponse.userID}/permissions`, function (responsePerms) {
                    if (responsePerms.data.every((perm) => perm.status === 'granted')) {
                        resolve(response.authResponse.accessToken);
                    } else {
                        reject({
                            errorMessage:'Integration failed. Granted permissions are not sufficient.'
                        });
                    }
                });
            } else {
                reject({
                    errorMessage:'Integration failed. Facebook request error.'
                });
            }
        }, {
            scope: data.scope,
        });
    });
}